import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { ProductChart } from "./ProductChart";
import { Tabs } from "@mantine/core";
import { useParams } from "react-router-dom";
import ProductsOverview from "./ProductsOverview";

export const ProductsStatistic = () => {
  const { lang } = useParams();
  const [_] = useTranslation("global");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";

  return (
    <div className="flex-grow-1 stats-component" dir={box_head_dir}>
      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 className="fs-2 mb-4" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.productsOverview")}
          </h3>
        </div>

        <Tabs defaultValue="all_products" className="w-100">
          <Helmet>
            <title>{_("panel.productsOverview")}</title>
          </Helmet>
          <Tabs.List>
            <Tabs.Tab
              value="all_products"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.orders")}
            </Tabs.Tab>
            <Tabs.Tab value="chart" className="fs-5" color="rgb(89, 198, 201)">
              {_("panel.statistics_title_chart")}
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="all_products">
            <ProductsOverview />
          </Tabs.Panel>

          <Tabs.Panel value="chart">
            <ProductChart />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
};
